<template>
    <ul class="my-4 float-left mainnav">
        <li>
            <router-link v-bind:to="navigation.router" class="float-left">
                <span class="font-bold text-3xl md:text-5xl" @click="navshowFct">
                    <the-language :de="navigation.cat_name" :en="navigation.cat_name_en" />
                </span>
            </router-link>
            <template v-if="navigation.sub">
                <div class="showSub" @click="showSub = !showSub">
                    <div class="arrow" />
                </div>
                <ul class="sub pl-4" v-if="showSub">
                    <li v-for="navItems in navigation.sub" :key="navItems.sub" class="md:text-3xl pt-4" @click="navshowFct">
                        <sub-navi :subItem="navItems" />
                    </li>
                </ul>
            </template>
        </li>
    </ul>
</template>

<script>
    import { serverBus } from '../../main';
    import subNavi from './sub'
    import TheLanguage from "../TheLanguage";

    export default {
        name: 'TheMainNav',
        components: {
            TheLanguage,
            subNavi
        },
        data() {
            return {
                showSub: false
            }
        },
        props: {
            navigation: {
                type: Object,
                default: () => {
                }
            }
        },
        methods: {
            navshowFct() {
                serverBus.$emit('shownav', false);
            }
        }
    }

</script>

<style lang="scss" scoped>
    .showSub{
        float: left;
        .arrow{
            border: solid #FFF;
            border-width: 0 3px 3px 0;
            display: inline-block;
            padding: 3px;
            transform: rotate(45deg);
            margin: 5px 15px;
            cursor: pointer;
            @screen md{
                border-width: 0 8px 8px 0;
                padding: 12px;
                margin: 2px 25px;
            }
        }
    }
    .sub{
        clear: both;
    }
</style>

<style lang="scss">
    .mainnav{
        .router-link-exact-active{
            &:after{
                content: '';
                width: 100%;
                height: 4px;
                background: #FFF;
                display: block;
            }
        }
    }
</style>